export default class PaymentMethod {
    name = ""
    identifier = ""
}